/*
 * @Autor: 陈钊贤
 * @Version: 1.0
 * @Date: 2020-05-27 14:00:36
 * @LastEditors: 陈钊贤
 * @Description:
 * @LastEditTime: 2020-10-19 13:23:26
 */
import common from "./common";
import Vue from "vue";
import i18n from "@/config/i18n";
const time = (value, type) => {
    if (value) {
        if (typeof value === "number") {
            const typeStr = type || "yyyy-mm-dd hh:mm:ss";
            return common.userDate(value, typeStr);
        }
        else {
            return value;
        }
    }
    else {
        return "";
    }
};
const Fixed = (value, type) => {
    if (typeof value === "number" && !isNaN(value)) {
        const n = type && type >= 0 ? type : 2;
        return value.toFixed(n);
    }
    else {
        return 0;
    }
};
const defaultText = (value) => {
    if (value || value == 0) {
        return value;
    }
    else {
        return "--";
    }
};
export const percentage = (value) => {
    if (value > 0) {
        return value + "%";
    }
    else {
        return "-";
    }
};
export const percentageValue = (value, num) => {
    if (typeof value == "number") {
        num = 2 || num;
        value = parseFloat((value * 100).toFixed(num));
        return value + "%";
    }
    else {
        return "-";
    }
};
export const formatMinute = (value, type) => {
    // 默认是分钟, type  m  是秒
    if (type === "m") {
        if (value > 60) {
            let hour;
            let minute = Math.trunc(value / 60);
            const second = Math.trunc(value % 60);
            if (minute > 60) {
                hour = Math.trunc(minute / 60);
                minute = Math.trunc(minute % 60);
                return (hour +
                    "" +
                    i18n.t("unitText.xHours") +
                    minute +
                    i18n.t("unitText.minute") +
                    second +
                    i18n.t("unitText.seconds"));
            }
            else {
                return (minute +
                    "" +
                    i18n.t("unitText.minute") +
                    second +
                    i18n.t("unitText.seconds"));
            }
        }
        else {
            return value + "" + i18n.t("unitText.seconds");
        }
    }
    else if (type === "minute") {
        const minute = Math.trunc(value / 60);
        return minute + "" + i18n.t("unitText.minute");
    }
    else {
        if (value > 60) {
            const hour = Math.trunc(value / 60);
            const minute = Math.trunc(value % 60);
            return (hour +
                "" +
                i18n.t("unitText.xHours") +
                minute +
                i18n.t("unitText.minute"));
        }
        else if (value > 0) {
            return Math.trunc(value) + "" + i18n.t("unitText.minute");
        }
        else {
            return "0" + i18n.t("unitText.minute");
        }
    }
};
Vue.filter("time", time);
Vue.filter("toFixed", Fixed);
Vue.filter("defaultText", defaultText);
Vue.filter("percentage", percentage);
Vue.filter("percentageValue", percentageValue);
Vue.filter("formatMinute", formatMinute);
